/**
 * Created by Ivan on 19.10.2026
 */

const DiscoPartyWindow = Prefab.createWindow("discoparty", "discoparty_window_prefab_json", { bundles: ["reward_window"] });
